import React from 'react';
import { cn } from '../utils/cn';
import { Container } from './Container';

const backgrounds = {
  white: 'bg-white',
  muted: 'bg-gradient-to-b from-slate-50 via-white to-slate-50',
  dark: 'bg-gradient-to-br from-gray-900 to-gray-800 text-white',
  primary: 'bg-gradient-to-br from-primary-900 to-accent-900 text-white',
};

export function Section({
  children,
  id,
  background = 'white',
  padding = 'lg',
  containerSize = 'lg',
  className,
  header,
}) {
  const paddings = { sm: 'py-12', md: 'py-16', lg: 'py-20', xl: 'py-24' };

  return (
    <section id={id} className={cn('relative overflow-hidden', backgrounds[background], paddings[padding], className)}>
      <Container size={containerSize}>
        {header && (
          <header className="text-center mb-12 md:mb-16">
            {header.eyebrow && (
              <span className="inline-block text-sm font-semibold tracking-widest uppercase text-primary-600 mb-3">
                {header.eyebrow}
              </span>
            )}
            {header.title && (
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">{header.title}</h2>
            )}
            {header.description && (
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">{header.description}</p>
            )}
          </header>
        )}
        {children}
      </Container>
    </section>
  );
}
